import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { deserialize, serializable } from 'serializr';
import { NlpTemplate } from '@testsigmainc/models';

export class NlpTemplateExample extends Base implements PageObject {
  @serializable
  public templateId: number;
  @serializable
  public description: string;
  @serializable
  public example: string;
  @serializable
  public application: string;
  @serializable
  public data: string;

  public template: NlpTemplate;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(NlpTemplateExample, input));
  }
}
